module.exports = __webpack_public_path__ + "components/guide-page/static/icon-wetsuit--winter-c80d648c2f0170575170950c4992453f.svg";